import Smartphones from 'Events/Events/views/EventsView/containers/Smartphones'
import Tablets from 'Events/Events/views/EventsView/containers/Tablets'

import {getCurrentDeviceView} from 'shared/helpers/utils'

const EventsView = getCurrentDeviceView(Smartphones, Tablets)

export default EventsView
